import { toString as toString_1, Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { MainModels_QuizProdCard, MediaCategory, RESP$1_$reflection, MainModels_QuizProdRecord_$reflection, MainModels_QuizProdCard_$reflection } from "../shared/Shared.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, record_type, option_type, union_type, unit_type, bool_type, int32_type, string_type, class_type, list_type, anonRecord_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { urlForResults, urlForAud, urlForReg, urlForAdmin, taggedMsg, DeleteForm, DeleteForm_Toggle_Z5CE7ED6, uploadFileToS3Cmd, apiCmd, noCmd, DeleteForm_$reflection, TRESP$2_$reflection } from "./Common.fs.js";
import * as light from "flatpickr/dist/themes/light.css";
import { empty as empty_1, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library.4.10.0/String.js";
import { isEmpty, sortBy, reverse, singleton as singleton_1, empty, cons, ofArray, filter } from "./fable_modules/fable-library.4.10.0/List.js";
import { comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import * as react from "react";
import { deleteForm, imgArea128, errors } from "./MainTemplates.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { empty as empty_2, singleton, append, collect, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { toString } from "./fable_modules/fable-library.4.10.0/Date.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { value as value_7 } from "./fable_modules/fable-library.4.10.0/Option.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { Value as Value_1, flatpickr, OnChange, TimeTwentyFour, EnableTimePicker, ClassName } from "./Flatpickr.fs.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CreateQuiz", "CreateQuizResp", "GetQuizzesResp", "Exn", "DeleteError", "ToggleCard", "GetCardResp", "UpdateStartTime", "UpdateName", "UpdateMixlrCode", "UpdateEventPage", "UpdateWelcomeTxt", "UpdateInfoTxt", "UpdateFarewellTxt", "UpdateRegTxt", "UpdateIsPremoderated", "CancelCard", "SubmitCard", "SubmitCardResp", "QuizImgChanged", "QuizImgClear", "QuizImgUploaded", "ToggleDeleteForm", "DeleteFormUpdateText", "DeleteQuiz", "DeleteQuizResp"];
    }
}

export function Msg_$reflection() {
    return union_type("MainProdQuizzes.Msg", [], Msg, () => [[], [["Item", RESP$1_$reflection(anonRecord_type(["Card", MainModels_QuizProdCard_$reflection()], ["Record", MainModels_QuizProdRecord_$reflection()]))]], [["Item", RESP$1_$reflection(list_type(MainModels_QuizProdRecord_$reflection()))]], [["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", int32_type]], [["Item", RESP$1_$reflection(MainModels_QuizProdCard_$reflection())]], [["Item", class_type("System.DateTime")]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [], [], [["Item", RESP$1_$reflection(MainModels_QuizProdRecord_$reflection())]], [["Item", anonRecord_type(["File", class_type("Browser.Types.File", void 0)], ["Tag", int32_type])]], [["Item", unit_type]], [["quizId", int32_type], ["bucketKey", string_type]], [], [["Item", string_type]], [["Item", int32_type]], [["Item", TRESP$2_$reflection(int32_type, unit_type)]]]);
}

export class Model extends Record {
    constructor(Quizzes, Card, Errors, CardIsLoading, Form) {
        super();
        this.Quizzes = Quizzes;
        this.Card = Card;
        this.Errors = Errors;
        this.CardIsLoading = CardIsLoading;
        this.Form = Form;
    }
}

export function Model_$reflection() {
    return record_type("MainProdQuizzes.Model", [], Model, () => [["Quizzes", list_type(MainModels_QuizProdRecord_$reflection())], ["Card", option_type(MainModels_QuizProdCard_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["CardIsLoading", option_type(int32_type)], ["Form", option_type(DeleteForm_$reflection())]]);
}

export const doval$004014 = light;

export function loading(quizId, model) {
    return new Model(model.Quizzes, model.Card, model.Errors, quizId, model.Form);
}

export function editing(model) {
    return new Model(model.Quizzes, model.Card, model.Errors, void 0, model.Form);
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Quizzes, model.Card, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.CardIsLoading, model.Form);
}

export function delError(id, model) {
    return new Model(model.Quizzes, model.Card, FSharpMap__Remove(model.Errors, id), model.CardIsLoading, model.Form);
}

export function toggleCard(api, quizId, model) {
    if (model.CardIsLoading == null) {
        const matchValue_1 = model.Card;
        let matchResult, card_2;
        if (matchValue_1 != null) {
            if (matchValue_1.QuizId === quizId) {
                matchResult = 0;
                card_2 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return noCmd(new Model(model.Quizzes, void 0, model.Errors, model.CardIsLoading, void 0));
            default:
                return apiCmd(api.getProdQuizCard, {
                    QuizId: quizId,
                }, (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(3, [Item_1])), loading(quizId, new Model(model.Quizzes, void 0, model.Errors, model.CardIsLoading, void 0)));
        }
    }
    else {
        return noCmd(model);
    }
}

export function updateCard(f, model) {
    const matchValue = model.Card;
    if (matchValue != null) {
        return new Model(model.Quizzes, f(matchValue), model.Errors, model.CardIsLoading, model.Form);
    }
    else {
        return model;
    }
}

export function validateBrand(txt) {
    if (isNullOrWhiteSpace(txt)) {
        return "Brand is required";
    }
    else {
        return "";
    }
}

export function validateName(txt) {
    if (isNullOrWhiteSpace(txt)) {
        return "Name is required";
    }
    else {
        return "";
    }
}

export function validateStartTime(dt) {
    if (dt == null) {
        return "Start Time is required";
    }
    else {
        return "";
    }
}

export function validate(card_1) {
    return filter((s) => (s !== ""), ofArray([validateName(card_1.Name), validateStartTime(card_1.StartTime)]));
}

export function submitCard(api, model) {
    const matchValue = model.Card;
    if (matchValue == null) {
        return noCmd(model);
    }
    else {
        const card_1 = matchValue;
        return apiCmd(api.updateProdQuizCard, card_1, (Item) => (new Msg(18, [Item])), (Item_1) => (new Msg(3, [Item_1])), loading(card_1.QuizId, model));
    }
}

export function replaceRecord(record, model) {
    return new Model(cons(record, filter((q) => (q.QuizId !== record.QuizId), model.Quizzes)), model.Card, model.Errors, model.CardIsLoading, model.Form);
}

export function uploadFile(quizId, api, file, model) {
    if (file.size > (1024 * 128)) {
        return noCmd(addError("max image size is 128K", model));
    }
    else {
        return [loading(quizId, model), uploadFileToS3Cmd(api.getUploadUrl, new MediaCategory(0, []), file, (key) => (new Msg(21, [quizId, key])), (Item) => (new Msg(3, [Item])))];
    }
}

export function updateMixlrCode(txt, model) {
    return updateCard((c) => (new MainModels_QuizProdCard(c.QuizId, c.StartTime, c.Name, c.ImgKey, c.ListenToken, c.ResultsToken, c.AdminToken, c.RegToken, c.WelcomeText, c.FarewellText, c.RegText, c.InfoText, c.WithPremoderation, c.EventPage, txt)), model);
}

export function toggleDeleteForm(model) {
    return new Model(model.Quizzes, model.Card, model.Errors, model.CardIsLoading, DeleteForm_Toggle_Z5CE7ED6(model.Form));
}

export function updateDeleteForm(f, model) {
    const matchValue = model.Form;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(model.Quizzes, model.Card, model.Errors, model.CardIsLoading, f(matchValue));
    }
}

export function afterQuizDeletion(quizId, model) {
    return new Model(filter((q) => (q.QuizId !== quizId), model.Quizzes), void 0, model.Errors, model.CardIsLoading, void 0);
}

export function init(api, user) {
    return apiCmd(api.getProdQuizzes, void 0, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1])), new Model(empty(), void 0, empty_1({
        Compare: comparePrimitives,
    }), void 0, void 0));
}

export function update(api, user, msg, cm) {
    let matchResult, res_4, res_5, quizId, res_6, dt, txt_4, txt_5, txt_6, txt_7, txt_8, txt_9, txt_10, b, res_7, res_8, bucketKey, txt_11, quizId_2, quizId_3, txt_12, id, ex, txt_14;
    switch (msg.tag) {
        case 1: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 1;
                res_4 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 27;
                    txt_14 = activePatternResult;
                }
                else {
                    matchResult = 28;
                }
            }
            break;
        }
        case 2: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 2;
                res_5 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 27;
                    txt_14 = activePatternResult_1;
                }
                else {
                    matchResult = 28;
                }
            }
            break;
        }
        case 5: {
            matchResult = 3;
            quizId = msg.fields[0];
            break;
        }
        case 6: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 4;
                res_6 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 27;
                    txt_14 = activePatternResult_2;
                }
                else {
                    matchResult = 28;
                }
            }
            break;
        }
        case 7: {
            matchResult = 5;
            dt = msg.fields[0];
            break;
        }
        case 8: {
            matchResult = 6;
            txt_4 = msg.fields[0];
            break;
        }
        case 10: {
            matchResult = 7;
            txt_5 = msg.fields[0];
            break;
        }
        case 9: {
            matchResult = 8;
            txt_6 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 9;
            txt_7 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 10;
            txt_8 = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 11;
            txt_9 = msg.fields[0];
            break;
        }
        case 14: {
            matchResult = 12;
            txt_10 = msg.fields[0];
            break;
        }
        case 15: {
            matchResult = 13;
            b = msg.fields[0];
            break;
        }
        case 16: {
            matchResult = 14;
            break;
        }
        case 17: {
            matchResult = 15;
            break;
        }
        case 18: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 16;
                res_7 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_3;
                const msg_4 = msg;
                const pi_1_3 = tryFind((pi_4) => (name(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_3 == null) {
                    activePatternResult_3 = void 0;
                }
                else {
                    const pi$0027_3 = pi_1_3;
                    let msgType_3;
                    let copyOfStruct_3 = msg_4;
                    msgType_3 = Msg_$reflection();
                    if (isUnion(msgType_3)) {
                        const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                        if (objArray_4.length === 1) {
                            try {
                                const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_3 = ((name(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                            }
                            catch (matchValue_3) {
                                activePatternResult_3 = void 0;
                            }
                        }
                        else {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                if (activePatternResult_3 != null) {
                    matchResult = 27;
                    txt_14 = activePatternResult_3;
                }
                else {
                    matchResult = 28;
                }
            }
            break;
        }
        case 20: {
            matchResult = 17;
            break;
        }
        case 19: {
            matchResult = 18;
            res_8 = msg.fields[0];
            break;
        }
        case 21: {
            matchResult = 19;
            bucketKey = msg.fields[1];
            break;
        }
        case 22: {
            matchResult = 20;
            break;
        }
        case 23: {
            matchResult = 21;
            txt_11 = msg.fields[0];
            break;
        }
        case 24: {
            matchResult = 22;
            quizId_2 = msg.fields[0];
            break;
        }
        case 25: {
            if (msg.fields[0].Rsp.Value.tag === 1) {
                matchResult = 24;
                txt_12 = msg.fields[0].Rsp.Value.fields[0];
            }
            else {
                matchResult = 23;
                quizId_3 = msg.fields[0].Tag;
            }
            break;
        }
        case 4: {
            matchResult = 25;
            id = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 26;
            ex = msg.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return apiCmd(api.createQuiz, void 0, (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(3, [Item_1])), cm);
        case 1:
            return noCmd(new Model(cons(res_4.Record, cm.Quizzes), res_4.Card, cm.Errors, cm.CardIsLoading, cm.Form));
        case 2:
            return noCmd(new Model(res_5, cm.Card, cm.Errors, cm.CardIsLoading, cm.Form));
        case 3:
            return toggleCard(api, quizId, cm);
        case 4:
            return noCmd(editing(new Model(cm.Quizzes, res_6, cm.Errors, cm.CardIsLoading, cm.Form)));
        case 5:
            return noCmd(updateCard((c) => (new MainModels_QuizProdCard(c.QuizId, dt, c.Name, c.ImgKey, c.ListenToken, c.ResultsToken, c.AdminToken, c.RegToken, c.WelcomeText, c.FarewellText, c.RegText, c.InfoText, c.WithPremoderation, c.EventPage, c.MixlrCode)), cm));
        case 6:
            return noCmd(updateCard((c_1) => (new MainModels_QuizProdCard(c_1.QuizId, c_1.StartTime, txt_4, c_1.ImgKey, c_1.ListenToken, c_1.ResultsToken, c_1.AdminToken, c_1.RegToken, c_1.WelcomeText, c_1.FarewellText, c_1.RegText, c_1.InfoText, c_1.WithPremoderation, c_1.EventPage, c_1.MixlrCode)), cm));
        case 7:
            return noCmd(updateCard((c_2) => (new MainModels_QuizProdCard(c_2.QuizId, c_2.StartTime, c_2.Name, c_2.ImgKey, c_2.ListenToken, c_2.ResultsToken, c_2.AdminToken, c_2.RegToken, c_2.WelcomeText, c_2.FarewellText, c_2.RegText, c_2.InfoText, c_2.WithPremoderation, txt_5, c_2.MixlrCode)), cm));
        case 8:
            return noCmd(updateMixlrCode(txt_6, cm));
        case 9:
            return noCmd(updateCard((c_3) => (new MainModels_QuizProdCard(c_3.QuizId, c_3.StartTime, c_3.Name, c_3.ImgKey, c_3.ListenToken, c_3.ResultsToken, c_3.AdminToken, c_3.RegToken, txt_7, c_3.FarewellText, c_3.RegText, c_3.InfoText, c_3.WithPremoderation, c_3.EventPage, c_3.MixlrCode)), cm));
        case 10:
            return noCmd(updateCard((c_4) => (new MainModels_QuizProdCard(c_4.QuizId, c_4.StartTime, c_4.Name, c_4.ImgKey, c_4.ListenToken, c_4.ResultsToken, c_4.AdminToken, c_4.RegToken, c_4.WelcomeText, c_4.FarewellText, c_4.RegText, txt_8, c_4.WithPremoderation, c_4.EventPage, c_4.MixlrCode)), cm));
        case 11:
            return noCmd(updateCard((c_5) => (new MainModels_QuizProdCard(c_5.QuizId, c_5.StartTime, c_5.Name, c_5.ImgKey, c_5.ListenToken, c_5.ResultsToken, c_5.AdminToken, c_5.RegToken, c_5.WelcomeText, txt_9, c_5.RegText, c_5.InfoText, c_5.WithPremoderation, c_5.EventPage, c_5.MixlrCode)), cm));
        case 12:
            return noCmd(updateCard((c_6) => (new MainModels_QuizProdCard(c_6.QuizId, c_6.StartTime, c_6.Name, c_6.ImgKey, c_6.ListenToken, c_6.ResultsToken, c_6.AdminToken, c_6.RegToken, c_6.WelcomeText, c_6.FarewellText, txt_10, c_6.InfoText, c_6.WithPremoderation, c_6.EventPage, c_6.MixlrCode)), cm));
        case 13:
            return noCmd(updateCard((c_7) => (new MainModels_QuizProdCard(c_7.QuizId, c_7.StartTime, c_7.Name, c_7.ImgKey, c_7.ListenToken, c_7.ResultsToken, c_7.AdminToken, c_7.RegToken, c_7.WelcomeText, c_7.FarewellText, c_7.RegText, c_7.InfoText, b, c_7.EventPage, c_7.MixlrCode)), cm));
        case 14:
            return noCmd(new Model(cm.Quizzes, void 0, cm.Errors, cm.CardIsLoading, cm.Form));
        case 15:
            return submitCard(api, cm);
        case 16:
            return noCmd(replaceRecord(res_7, editing(new Model(cm.Quizzes, void 0, cm.Errors, cm.CardIsLoading, cm.Form))));
        case 17:
            return noCmd(updateCard((c_8) => (new MainModels_QuizProdCard(c_8.QuizId, c_8.StartTime, c_8.Name, "", c_8.ListenToken, c_8.ResultsToken, c_8.AdminToken, c_8.RegToken, c_8.WelcomeText, c_8.FarewellText, c_8.RegText, c_8.InfoText, c_8.WithPremoderation, c_8.EventPage, c_8.MixlrCode)), cm));
        case 18:
            return uploadFile(res_8.Tag, api, res_8.File, cm);
        case 19:
            return noCmd(updateCard((c_9) => (new MainModels_QuizProdCard(c_9.QuizId, c_9.StartTime, c_9.Name, bucketKey, c_9.ListenToken, c_9.ResultsToken, c_9.AdminToken, c_9.RegToken, c_9.WelcomeText, c_9.FarewellText, c_9.RegText, c_9.InfoText, c_9.WithPremoderation, c_9.EventPage, c_9.MixlrCode)), editing(cm)));
        case 20:
            return noCmd(toggleDeleteForm(cm));
        case 21:
            return noCmd(updateDeleteForm((form) => (new DeleteForm(txt_11, "", form.IsSending)), cm));
        case 22:
            return apiCmd(api.deleteQuiz, {
                QuizId: quizId_2,
            }, (rsp) => taggedMsg((Item_2) => (new Msg(25, [Item_2])), quizId_2, rsp), (Item_3) => (new Msg(3, [Item_3])), updateDeleteForm((form_1) => (new DeleteForm(form_1.ConfirmText, form_1.FormError, true)), cm));
        case 23:
            return noCmd(afterQuizDeletion(quizId_3, cm));
        case 24:
            return noCmd(updateDeleteForm((form_2) => (new DeleteForm(form_2.ConfirmText, txt_12, false)), cm));
        case 25:
            return noCmd(delError(id, cm));
        case 26:
            return noCmd(editing(addError(ex.message, cm)));
        case 27:
            return noCmd(editing(addError(txt_14, cm)));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, appSettings, model) {
    let children_8, children_6, children_4, children_50, children_22, children_20, props_10, props_12, props_16, props_18, children_48;
    const children_52 = [(children_8 = [react.createElement("div", {
        className: "level-left",
    }), (children_6 = [(children_4 = [react.createElement("button", {
        className: "button is-dark",
        onClick: (_arg) => {
            dispatch(new Msg(0, []));
        },
    }, "Create New Quiz")], react.createElement("p", {
        className: "level-item",
    }, ...children_4))], react.createElement("div", {
        className: "level-right",
    }, ...children_6))], react.createElement("nav", {
        className: "level",
    }, ...children_8)), errors(dispatch, (Item) => (new Msg(4, [Item])), model.Errors), (children_50 = [(children_22 = [(children_20 = [(props_10 = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props_10, 1), "")), (props_12 = [["style", {
        width: "120px",
    }]], react.createElement("th", keyValueList(props_12, 1), "Start Time")), react.createElement("th", {}, "Name"), (props_16 = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props_16, 1), "Status")), (props_18 = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props_18, 1), "Admin"))], react.createElement("tr", {}, ...children_20))], react.createElement("thead", {}, ...children_22)), (children_48 = toList(delay(() => collect((quiz) => {
        let children_40, children_26, props_24, children_24, children_28, matchValue_2, children_32, children_38, props_36, children_36, children_34;
        let hasCard;
        const matchValue = model.Card;
        let matchResult, card_2;
        if (matchValue != null) {
            if (matchValue.QuizId === quiz.QuizId) {
                matchResult = 0;
                card_2 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                hasCard = true;
                break;
            }
            default:
                hasCard = false;
        }
        let isLoading;
        const matchValue_1 = model.CardIsLoading;
        let matchResult_1, id_1;
        if (matchValue_1 != null) {
            if (matchValue_1 === quiz.QuizId) {
                matchResult_1 = 0;
                id_1 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                isLoading = true;
                break;
            }
            default:
                isLoading = false;
        }
        return append(singleton((children_40 = [(children_26 = [(props_24 = [Helpers_classList([["button", true], ["is-small", true], ["is-loading", isLoading]]), new DOMAttr(40, [(_arg_1) => {
            dispatch(new Msg(5, [quiz.QuizId]));
        }])], (children_24 = [hasCard ? "-" : "+"], react.createElement("button", keyValueList(props_24, 1), ...children_24)))], react.createElement("th", {}, ...children_26)), (children_28 = [(matchValue_2 = quiz.StartTime, (matchValue_2 == null) ? "???" : toString(matchValue_2, "dd/MM HH:mm"))], react.createElement("th", {}, ...children_28)), react.createElement("td", {}, quiz.Name), (children_32 = [toString_1(quiz.Status)], react.createElement("td", {}, ...children_32)), (children_38 = [(props_36 = [new HTMLAttr(94, [urlForAdmin(quiz.QuizId, quiz.AdminToken)]), new HTMLAttr(157, ["_blank"])], (children_36 = ["link", (children_34 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-external-link-alt"])), [])], react.createElement("span", {
            className: "icon",
        }, ...children_34))], react.createElement("a", keyValueList(props_36, 1), ...children_36)))], react.createElement("td", {}, ...children_38))], react.createElement("tr", {}, ...children_40))), delay(() => {
            let children_46, children_44;
            return hasCard ? singleton((children_46 = [react.createElement("th", {}), (children_44 = [card(dispatch, appSettings, value_7(model.Card), model.Form, isLoading)], react.createElement("td", {
                colSpan: 5,
            }, ...children_44))], react.createElement("tr", {}, ...children_46))) : empty_2();
        }));
    }, reverse(sortBy((q) => q.QuizId, model.Quizzes, {
        Compare: comparePrimitives,
    }))))), react.createElement("tbody", {}, ...children_48))], react.createElement("table", {
        className: "table is-fullwidth is-hoverable",
    }, ...children_50))];
    return react.createElement("div", {}, ...children_52);
}

export function card(dispatch, appSettings, card_1, form, isLoading) {
    const children_118 = toList(delay(() => {
        let children_98, children_52, children_8, children_18, children_16, children_26, children_24, children_34, children_32, children_42, children_40, children_50, children_48, children_96, children_58, children_56, children_70, children_62, children_68, children_74, children_88, children_86, children_94, children_92, children_90;
        return append(singleton((children_98 = [(children_52 = [(children_8 = toList(delay(() => {
            let children_2;
            return append(singleton((children_2 = ["Quiz Name", react.createElement("span", {
                className: "has-text-danger",
            }, "*")], react.createElement("label", {
                className: "label",
            }, ...children_2))), delay(() => {
                let children_4, props_4;
                const error = validateName(card_1.Name);
                return append(singleton((children_4 = [(props_4 = [Helpers_classList([["input", true], ["is-danger", error !== ""]]), new HTMLAttr(159, ["text"]), new HTMLAttr(128, ["BIZZ QUIZZ #3"]), new HTMLAttr(115, [128]), ["ref", (e) => {
                    Internal_updateInputValue(card_1.Name, e);
                }], new DOMAttr(9, [(ev) => {
                    dispatch(new Msg(8, [ev.target.value]));
                }])], react.createElement("input", keyValueList(props_4, 1)))], react.createElement("div", {
                    className: "control",
                }, ...children_4))), delay(() => singleton(react.createElement("p", {
                    className: "help is-danger",
                }, error))));
            }));
        })), react.createElement("div", {
            className: "field",
        }, ...children_8)), (children_18 = [(children_16 = toList(delay(() => {
            let children_12;
            return append(singleton((children_12 = ["Start Time", react.createElement("span", {
                className: "has-text-danger",
            }, "*")], react.createElement("label", {
                className: "label",
            }, ...children_12))), delay(() => {
                let matchValue;
                const error_1 = validateStartTime(card_1.StartTime);
                const opts = ofArray([ClassName("input" + ((error_1 !== "") ? " is-danger" : "")), EnableTimePicker(true), TimeTwentyFour(true), OnChange((arg) => {
                    dispatch(new Msg(7, [arg]));
                })]);
                return append(singleton(flatpickr((matchValue = card_1.StartTime, (matchValue != null) ? cons(Value_1(matchValue), opts) : opts))), delay(() => singleton(react.createElement("p", {
                    className: "help is-danger",
                }, error_1))));
            }));
        })), react.createElement("div", {
            className: "control",
        }, ...children_16))], react.createElement("div", {
            className: "field is-grouped",
        }, ...children_18)), (children_26 = [react.createElement("label", {
            className: "label",
        }, "Welcome Message"), (children_24 = [react.createElement("textarea", {
            className: "textarea",
            placeholder: "Describe your quiz",
            maxLength: 512,
            ref: (e_1) => {
                Internal_updateInputValue(card_1.WelcomeText, e_1);
            },
            onChange: (ev_1) => {
                dispatch(new Msg(11, [ev_1.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_24))], react.createElement("div", {
            className: "field",
        }, ...children_26)), (children_34 = [react.createElement("label", {
            className: "label",
        }, "Farewell Message"), (children_32 = [react.createElement("textarea", {
            className: "textarea",
            placeholder: "Say goodbye to your audience",
            maxLength: 512,
            ref: (e_2) => {
                Internal_updateInputValue(card_1.FarewellText, e_2);
            },
            onChange: (ev_2) => {
                dispatch(new Msg(13, [ev_2.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_32))], react.createElement("div", {
            className: "field",
        }, ...children_34)), (children_42 = [react.createElement("label", {
            className: "label",
        }, "Registration Message"), (children_40 = [react.createElement("textarea", {
            className: "textarea",
            placeholder: "Instruction for registration",
            maxLength: 512,
            ref: (e_3) => {
                Internal_updateInputValue(card_1.RegText, e_3);
            },
            onChange: (ev_3) => {
                dispatch(new Msg(14, [ev_3.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_40))], react.createElement("div", {
            className: "field",
        }, ...children_42)), (children_50 = [react.createElement("label", {
            className: "label",
        }, "Information for the registered teams"), (children_48 = [react.createElement("textarea", {
            className: "textarea",
            placeholder: "private zoom link",
            maxLength: 512,
            ref: (e_4) => {
                Internal_updateInputValue(card_1.InfoText, e_4);
            },
            onChange: (ev_4) => {
                dispatch(new Msg(12, [ev_4.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_48))], react.createElement("div", {
            className: "field",
        }, ...children_50))], react.createElement("div", {
            className: "column",
        }, ...children_52)), (children_96 = [(children_58 = [react.createElement("label", {
            className: "label",
        }, "Event Page"), (children_56 = [react.createElement("input", {
            className: "input",
            type: "text",
            placeholder: "Link to facebook event or telegram",
            maxLength: 128,
            ref: (e_5) => {
                Internal_updateInputValue(card_1.EventPage, e_5);
            },
            onChange: (ev_5) => {
                dispatch(new Msg(10, [ev_5.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_56))], react.createElement("div", {
            className: "field",
        }, ...children_58)), (children_70 = [react.createElement("label", {
            className: "label",
        }, "Mixlr Login"), (children_62 = [react.createElement("input", {
            className: "input",
            type: "text",
            placeholder: "",
            maxLength: 128,
            ref: (e_6) => {
                Internal_updateInputValue(card_1.MixlrCode, e_6);
            },
            onChange: (ev_6) => {
                dispatch(new Msg(9, [ev_6.target.value]));
            },
        })], react.createElement("div", {
            className: "control",
        }, ...children_62)), (children_68 = ["https://", react.createElement("span", {
            className: "has-text-danger",
        }, "LOGIN"), ".mixlr.com/embed from ", react.createElement("a", {
            href: "https://creators.mixlr.com/settings/embed-player/edit",
        }, "Widget code")], react.createElement("small", {}, ...children_68))], react.createElement("div", {
            className: "field",
        }, ...children_70)), (children_74 = toList(delay(() => append(singleton(react.createElement("label", {
            className: "label",
        }, "Quiz picture (128x128) 128K size max")), delay(() => imgArea128(card_1.QuizId, isLoading, (arg_1) => {
            dispatch(new Msg(19, [arg_1]));
        }, () => {
            dispatch(new Msg(20, [void 0]));
        }, appSettings.MediaHost, card_1.ImgKey, "/logo256.png", "Reset to default"))))), react.createElement("div", {
            className: "field",
        }, ...children_74)), (children_88 = [react.createElement("label", {
            className: "label",
        }, "Application links"), (children_86 = toList(delay(() => {
            let children_84;
            const link = (caption, href) => {
                let children_80, children_78;
                const children_82 = [caption, " ", (children_80 = ["link", (children_78 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-external-link-alt"])), [])], react.createElement("span", {
                    className: "icon",
                }, ...children_78))], react.createElement("a", {
                    href: href,
                    target: "_blank",
                }, ...children_80))];
                return react.createElement("li", {}, ...children_82);
            };
            return singleton((children_84 = [link("Admin", urlForAdmin(card_1.QuizId, card_1.AdminToken)), link("Registration", urlForReg(card_1.QuizId, card_1.RegToken)), link("Audience", urlForAud(card_1.QuizId, card_1.ListenToken)), link("Results Page", urlForResults(card_1.QuizId, card_1.Name, card_1.ImgKey, card_1.ResultsToken, appSettings.MediaHost))], react.createElement("ul", {}, ...children_84)));
        })), react.createElement("div", {
            className: "content",
        }, ...children_86))], react.createElement("div", {
            className: "field",
        }, ...children_88)), (children_94 = [(children_92 = [(children_90 = [react.createElement("input", {
            type: "checkbox",
            checked: card_1.WithPremoderation,
            onChange: (ev_7) => {
                dispatch(new Msg(15, [ev_7.target.checked]));
            },
        }), " registration is moderated"], react.createElement("label", {
            className: "checkbox",
        }, ...children_90))], react.createElement("div", {
            className: "control",
        }, ...children_92))], react.createElement("div", {
            className: "field",
        }, ...children_94))], react.createElement("div", {
            className: "column",
        }, ...children_96))], react.createElement("div", {
            className: "columns",
        }, ...children_98))), delay(() => {
            let children_116, children_110, children_108, children_102, children_106, children_114;
            const matchValue_1 = form;
            if (matchValue_1 == null) {
                return singleton((children_116 = [(children_110 = [(children_108 = [(children_102 = toList(delay(() => {
                    const hasErrors = !isEmpty(validate(card_1));
                    return singleton(react.createElement("button", {
                        className: "button is-dark ",
                        disabled: hasErrors,
                        onClick: (_arg) => {
                            dispatch(new Msg(17, []));
                        },
                    }, "Submit"));
                })), react.createElement("div", {
                    className: "control",
                }, ...children_102)), (children_106 = [react.createElement("button", {
                    className: "button",
                    onClick: (_arg_1) => {
                        dispatch(new Msg(16, []));
                    },
                }, "Cancel")], react.createElement("div", {
                    className: "control",
                }, ...children_106))], react.createElement("div", {
                    className: "field is-grouped",
                }, ...children_108))], react.createElement("div", {
                    className: "level-left",
                }, ...children_110)), (children_114 = [react.createElement("button", {
                    className: "button is-danger ",
                    onClick: (_arg_2) => {
                        dispatch(new Msg(22, []));
                    },
                }, "Delete")], react.createElement("div", {
                    className: "level-right",
                }, ...children_114))], react.createElement("nav", {
                    className: "level",
                }, ...children_116)));
            }
            else {
                const fm = matchValue_1;
                return singleton(deleteForm(dispatch, "Type name of the Quiz to confirm", card_1.Name, fm.ConfirmText, fm.IsSending, fm.FormError, new Msg(22, []), (Item_3) => (new Msg(23, [Item_3])), new Msg(24, [card_1.QuizId])));
            }
        }));
    }));
    return react.createElement("div", {}, ...children_118);
}

